import { TextField } from '@mui/material';

interface Props {
  label: string;
  value: string;
  name: string;
  className?: string;
  error?: any;
  hasError?: boolean;
  disabled?: boolean;
  handleBlur?: (e: any) => void;
  handleChange?: (e: any) => void;
  type?: string;
  placeholder?: string;
  multiline?: boolean;
  size?: 'small' | 'medium';
}

export const Input = ({
  label,
  value,
  name,
  className,
  error,
  hasError,
  handleBlur,
  handleChange,
  disabled = false,
  type = 'text',
  placeholder = '',
  multiline = false,
  size = 'small',
}: Props) => {
  // Caixa alta na digitacao: forca maiusculo apenas em campos de texto livre.
  // Nao afeta e-mail nem tipos nao-textuais (number, date, password, tel, url).
  const NAO_MAIUSCULO = ['email', 'number', 'date', 'password', 'tel', 'url'];
  const deveMaiusculo = !NAO_MAIUSCULO.includes(type) && !/mail/i.test(name);

  const onChangeMaiusculo = (e: any) => {
    if (!handleChange) return;
    if (deveMaiusculo && typeof e?.target?.value === 'string') {
      e.target.value = e.target.value.toUpperCase();
    }
    handleChange(e);
  };

  return (
    <TextField
      size={size}
      placeholder={placeholder}
      type={type}
      fullWidth
      label={label}
      value={value}
      name={name}
      InputLabelProps={{ shrink: true }}
      className={className}
      error={hasError}
      helperText={error}
      onBlur={handleBlur}
      onChange={onChangeMaiusculo}
      disabled={disabled}
      multiline={multiline}
    />
  );
};
